// const [deviceFormData, setDeviceFormData] = React.useState({
//     brand: "",
//     company: "",
//     dataProtocol: "",
//     description: "",
//     id: "",
//     model: "",
//     password: "",
//     software: "",
//     softwareVersion: "",
//     status: "ACTIVE",
// });

export const company_fields = () => [
  {
    key: 'companyName',
    type: 'text',
    inputType: 'text',
    placeHolder: 'Şirket Adı*',
    defaultValue: '',
  },
  {
    key: 'address',
    type: 'text',
    inputType: 'text',
    placeHolder: 'Adres',
    defaultValue: '',
  },
  {
    key: 'description',
    type: 'text',
    inputType: 'text',
    placeHolder: 'Açıklama',
    defaultValue: '',
  },

  // {
  //   key: 'brand',
  //   type: 'text',
  //   inputType: 'text',
  //   placeHolder: 'Marka',
  //   defaultValue: '',
  // },
  // {
  //   key: 'company',
  //   type: 'text',
  //   inputType: 'text',
  //   placeHolder: 'Şirket',
  //   defaultValue: '',
  // },
  // {
  //   key: 'description',
  //   type: 'text',
  //   inputType: 'text',
  //   placeHolder: 'Açıklama',
  //   defaultValue: '',
  // },
  // {
  //   key: 'model',
  //   type: 'text',
  //   inputType: 'text',
  //   placeHolder: 'Model',
  //   defaultValue: '',
  // },
  // {
  //   key: 'password',
  //   type: 'text',
  //   inputType: 'text',
  //   placeHolder: 'Şifre',
  //   defaultValue: '',
  // },
  // {
  //   key: 'software',
  //   type: 'text',
  //   inputType: 'text',
  //   placeHolder: 'Yazılım',
  //   defaultValue: '',
  // },
  // {
  //   key: 'softwareVersion',
  //   type: 'text',
  //   inputType: 'text',
  //   placeHolder: 'Yazılım Versiyonu',
  //   defaultValue: '',
  // },
];
